import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "@mui/material";
import Multiselect from "multiselect-react-dropdown";
import { Autocomplete } from "@mui/material";
import { ListItemIcon, ListItem, ListItemText } from "@material-ui/core";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import store from "../../../redux/store";
import IconButton from "@material-ui/core/IconButton";
import {
  CreateShort_URL,
  DeleteShortLink_Url,
  GroupList_Url,
  ShortLinkList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import { MESSAGE_TYPES } from "../../../provider/Enums";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";

export default class MessageQuestion extends Component {
  header = store.getState().header.header;
  interactiveQuestionTypeList =
    store.getState().staticData.interactiveQuestionTypeList;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  pledgeDonationIntegration =
    store.getState().appUserData.appUserData.pledgeDonationIntegration;
  constructor(props) {
    super(props);
    let action = props.action;
    let selectedGroups = [];
    for (let i = 0; i < props.data.selectedGroups?.length; i++) {
      const element = props.data.selectedGroups[i];
      selectedGroups.push(element?.smsGroup);
    }
    const type = props.data.questionType?.type;
    if (type === "SelectGroup") {
      this.getSelectGroupList(props.data.questionType, selectedGroups);
    } else if (type === "ConfirmGroup") {
      this.getConfirmGroupList(
        props.data.questionType,
        props.data?.groupToJoin
      );
    }

    this.state = {
      messageType: props.messageType,
      id: props.data.id,
      question: props.data.question !== "" ? props.data.question : "",
      questionType: props.data.questionType,
      selectedGroups: selectedGroups,
      smsVariablesList: props.smsVariablesList,
      operation: props.data.operation,
      index: props.srno,
      step: props.data.step,
      onDelete: props.onDelete,
      onChange: props.onChange,
      onSuccess: props.onSuccess,
      action: action,
      cursorPosition: 0,
      render: true,
      isDelete: false,
      copied: false,
      onQuestionItemAdd: props.onAdd,
      smsPledgeQuestion: [],
      groupToJoin: null,
      smsGroupList: [],
      shortLinkList: [],
      pageSize: 10,
      initialPage: 0,
      isPaging: false,
      alertVisible: false,
      discontinueText: props.data.discontinueText,
    };
  }

  getSelectGroupList(questiontype, selectedGroups) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    AdminFetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.props.onSuccess?.(questiontype, this.state.index);
          let selectedGroupsIds = [];
          let selectedItem = {};
          for (let i = 0; i < selectedGroups?.length; i++) {
            selectedItem = selectedGroups[i];
            selectedGroupsIds.push(selectedGroups[i]?.id);
          }
          let questionDescription =
            selectedGroups === undefined
              ? Utils.getSmsQuestionType(questiontype?.type, smsGroupList[0])
              : this.state.question;
          this.setState({
            smsGroupList: smsGroupList,
            selectedGroups: selectedGroups !== undefined ? selectedGroups : [],
            selectedGroupsIds: selectedGroupsIds,
            questionType: questiontype,
            question: questionDescription,
          });
        } 
      }
    );
  }
  getConfirmGroupList(questiontype, groupToJoinId) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    AdminFetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.props.onSuccess?.(questiontype, this.state.index);
          let groupToJoin =
            groupToJoinId !== undefined
              ? smsGroupList?.find((group) => group?.id === groupToJoinId)
              : Utils.getArrayElement(smsGroupList, 0);
          let questionDescription = Utils.getSmsQuestionType(
            questiontype?.type,
            groupToJoin?.name
          );
          this.setState({
            smsGroupList: smsGroupList,
            question: questionDescription,
            questionType: questiontype,
            groupToJoin: groupToJoin,
          });
        } 
      }
    );
  }

  deleteQuestionItem(e) {
    if (this.state.onDelete) {
      this.state.isDelete = true;
      this.state.onDelete(this.state, this.state.index);
    }
  }

  handleQuestionTextMessageChange(e) {
    let cursorPosition = e.target.selectionStart;
    let val = e.target.value;
    this.setState({ question: val, cursorPosition: cursorPosition });
    this.props.onChange();
  }
  handleInsertItMessageChange(e) {
    this.setState((prevState) => ({
      question: prevState.question?.includes(
        "Msg&data rates apply. STOP to quit."
      )
        ? prevState.question // Prevents duplicate text
        : prevState.question + " Msg&data rates apply. STOP to quit.",
    }));
  }
  handleQuestionInsert(selectedValue) {
    const shouldInsertSpace =
      this.state.cursorPosition > 0 &&
      this.state.question[this.state.cursorPosition - 1] !== " ";

    const newText =
      this.state.question.substring(0, this.state.cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value +
      this.state.question.substring(this.state.cursorPosition);

    this.setState(
      {
        question: newText,
        cursorPosition:
          this.state.cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        // Ensure cursor is placed correctly
        const input = document.getElementById("messageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(
            this.state.cursorPosition,
            this.state.cursorPosition
          );
        }
      }
    );
    // this.setState({
    //   question: `${this.state.question.substring(0, this.state.cursorPosition)} ${
    //     selectedValue.value
    //   } ${this.state.question.substring(this.state.cursorPosition)}`,
    // });
  }
  handleCreateShortLinkInsert(selectedValue) {
    this.setState({
      question: `${this.state.question} ${selectedValue}`,
    });
  }

  handleSMSQuestionTypeChange(selectedValue) {
    if (selectedValue?.type === "SelectGroup") {
      this.getSelectGroupList(selectedValue);
    } else if (selectedValue?.type === "ConfirmGroup") {
      this.getConfirmGroupList(selectedValue);
    } else {
      this.state.onSuccess(selectedValue, this.state.index);
      let questionDescription = Utils.getSmsQuestionType(
        selectedValue?.type,
        this.state.groupToJoin?.name
      );
      this.setState({
        questionType: selectedValue,
        question: questionDescription,
      });
    }
  }
  handleSMSGroupChange(selectedValue) {
    let questionDescription = Utils.getSmsQuestionType(
      this.state.questionType?.type,
      selectedValue?.name
    );
    this.setState({
      groupToJoin: selectedValue,
      question: questionDescription,
    });
  }
  addQuestionItem(e) {
    if (
      undefined !== this.state.onQuestionItemAdd &&
      null !== this.state.onQuestionItemAdd
    ) {
      this.state.onQuestionItemAdd(this.state);
    }
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e) => {
    this.getShortLinkList();
    this.setState({ open: true, anchorEl: e.currentTarget });
  };
  getShortLinkList() {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
    };
    AdminFetchServerData.callPostService(ShortLinkList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        }
      }
    );
  }
  handleShortlinkUrlChange(e) {
    this.setState({
      shortlinkUrl: e.target.value,
    });
  }

  createShortlinkToBackend() {
    if (this.state.shortlinkUrl === "") {
      return PtsAlert.error("Please enter URL");
    }
    const postObject = {
      header: this.header,
      url: this.state.shortlinkUrl,
      eventId: this.businessDomainId,
    };
    AdminFetchServerData.callPostService(CreateShort_URL, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortUrl = output.data.shortUrl;
          this.setState({
            shortUrl: shortUrl,
          });
        }
      }
    );
  }

  handleSmsVariableOnDrag(e) {
    e.preventDefault();
    let smsVariable = e.target.innerHTML;
    this.setState((prevState) => ({
      question: `${prevState.question.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.question.substring(
        this.state.cursorPosition
      )}`,
      cursorPosition: `${prevState.question.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.question.substring(
        this.state.cursorPosition
      )}`.length,
    }));
  }

  onSelectGroups(selectedList, selectedItem) {
    let selectedGroupsIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      selectedGroupsIds.push(selectedList[i].id);
    }
    this.setState({
      selectedGroups: selectedList,
      selectedGroupsIds: selectedGroupsIds,
      question: `${this.state.question}\n${selectedItem?.name}`,
    });
  }
  onRemoveGroups(selectedList, selectedItem) {
    let deleteQuestion = this.state.question?.replace(selectedItem?.name, "");
    let selectedGroupsIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      selectedGroupsIds.push(selectedList[i].id);
    }
    this.setState({
      selectedGroups: selectedList,
      selectedGroupsIds: selectedGroupsIds,
      question: deleteQuestion,
    });
  }

  handleYesToCountinueChange(e) {
    this.setState({ discontinueText: e.target.value });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  onCopy = (e) => {
    this.setState({ copied: true, alertVisible: true });
    setTimeout(() => {
      this.setState({ alertVisible: false });
    }, 1000);
  };

  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  handleCopy = (copiedIndex) => {
    if (copiedIndex !== null) {
      this.setState({
        alertVisible: false,
        copiedIndex: copiedIndex,
      });
    } else {
      this.setState({
        alertVisible: true,
        copiedIndex: copiedIndex,
      });
    }

    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  deleteShortLink(data) {
    const postObject = {
      header: this.header,
      shortLink: {
        id: data.id,
        eventId: this.businessDomainId,
      },
    };
    AdminFetchServerData.callPostService(DeleteShortLink_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        }
      })
      .catch((error) => {});
  }

  render() {
    this.textareaRef = React.createRef();
    if (this.state.render === false) {
      return "";
    }

    if (this.state.action === "edit") {
      return this.editMessageQuestion();
    } else {
      return this.viewMessageQuestion();
    }
  }

  editMessageQuestion() {
    const smsQuestionTypefilteredList = Utils.equalsIgnoreCase(
      this.props.messageType?.type,
      MESSAGE_TYPES.interactivePledge
    )
      ? this.interactiveQuestionTypeList.filter((type) => {
          return !["SelectGroup", "ConfirmGroup", "YesNo"].includes(type.type);
        })
      : this.interactiveQuestionTypeList.filter((type) => {
          return !["Pledge"].includes(type.type);
        });
    return (
      <>
        <div
          className="row mt-2"
          style={{
            background: this.state.rowBackgroundColor,
          }}
        >
          <div
            className="col-sm-1 align-self-center text-end"
            // style={{
            //   width: "110px",
            // }}
          >
            {this.props.iteamIndex !== 0 &&
              this.props.questionItems.length > 1 && (
                <i
                  class="fa-regular fa-trash-can"
                  aria-hidden="true"
                  style={{
                    borderRadius: "25%",
                    color: "#6A7B8E",
                    fontSize: "18px",
                    width: "30px",
                    minHeight: "30px",
                    padding: "3px",
                    alignContent: "center",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                  onClick={this.deleteQuestionItem.bind(this)}
                ></i>
              )}
          </div>
          <div className="col-sm-11">
            <div className="row d-flex p-0 ps-1">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-7 align-self-end">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className="form-label ms-2 mb-0"
                    >
                      {/* {this.state.questionType?.description} */}
                      Msg {this.state.step}
                    </label>
                  </div>
                  <div className="col-md-5 pe-0">
                    <Autocomplete
                      id="size-small-outlined"
                      size="small"
                      fullWidth
                      disableClearable
                      autoComplete="off"
                      options={smsQuestionTypefilteredList}
                      value={this.state.questionType}
                      getOptionLabel={(option) => option.description}
                      ListboxProps={{
                        sx: {
                          fontSize: 15,
                          "& .MuiAutocomplete-option": {
                            padding: "5px 15px",
                            fontSize: "15px",
                          }, // Reduce option padding
                          "& .MuiListItemText-root": { padding: 0, margin: 0 }, // Reduce ListItemText padding
                        },
                        style: {
                          maxHeight: "400px",
                          overflowY: "auto",
                        },
                      }}
                      renderOption={(props, option, state) => (
                        <ListItem {...props}>
                          <ListItemText primary={option.description} />
                          {option.description === "Pledge" && (
                            <ListItemIcon>
                              <i
                                className="fa fa-thermometer-three-quarters thermometer-icon"
                                aria-hidden="true"
                                style={{
                                  color: "#6a7b8e",
                                  fontSize: "1.5rem",
                                }}
                              ></i>
                            </ListItemIcon>
                          )}
                        </ListItem>
                      )}
                      defaultValue={this.state.questionType}
                      onChange={(event, value) => {
                        this.handleSMSQuestionTypeChange(value);
                      }}
                      inputprops={{ style: { textTransform: "capitalize" } }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Please Select"
                          variant="outlined"
                          size="small"
                          className="autoComplete"
                          // required
                          style={{ background: "#fff" }}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="row d-flex ms-2 mt-1 mb-2">
                  <div className="col-md-12 p-0">
                    <textarea
                      title=""
                      required
                      ref={this.textareaRef}
                      value={this.state.question}
                      onChange={this.handleQuestionTextMessageChange.bind(this)}
                      onBlur={this.handleQuestionTextMessageChange.bind(this)}
                      className="form-control"
                      id="messageBox"
                      rows="3"
                      // style={{ width: "518px" }}
                    />
                    {this.state.step === 1 && (
                      <span
                        className="ms-1"
                        style={{
                          fontSize: "11px",
                          color: "black",
                          fontWeight: "normal",
                        }}
                      >
                        Did you include opt-out language?{" "}
                        <span
                          className="anchortag"
                          onClick={this.handleInsertItMessageChange.bind(this)}
                        >
                          <u>Insert it.</u>
                        </span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {!Utils.equalsIgnoreCase(
                this.state.questionType?.type,
                "SelectGroup"
              ) &&
                !Utils.equalsIgnoreCase(
                  this.state.questionType?.type,
                  "ConfirmGroup"
                ) && (
                  <div className="col-md-3 mt-4 ms-3">
                    <ul
                      className="p-0"
                      style={{ listStyle: "none", marginTop: "18px" }}
                    >
                      {this.state.smsVariablesList?.map((data, index) => {
                        return (
                          <>
                            <li
                              className="d-flex mt-1 variableButton"
                              onClick={this.handleQuestionInsert.bind(
                                this,
                                data
                              )}
                            >
                              {data.name === "FirstName" && (
                                <IconButton className="pe-1">
                                  <ChatBubbleOutlineIcon
                                    // className="anchortag"
                                    style={{
                                      fontSize: "16px",
                                      width: "25px",
                                    }}
                                  />
                                </IconButton>
                              )}
                              {data.name === "EventName" && (
                                <IconButton className="pe-1">
                                  <i
                                    class="fa fa-plus"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: "16px",
                                      width: "25px",
                                    }}
                                  ></i>
                                </IconButton>
                              )}
                              {data.name === "PaymentLink" && (
                                <IconButton className="pe-1">
                                  <i
                                    class="fa fa-usd"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: "16px",
                                      width: "25px",
                                    }}
                                  ></i>
                                </IconButton>
                              )}
                              <span
                                style={{ cursor: "pointer" }}
                                key={index}
                                draggable
                              >
                                {data.description}
                              </span>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </div>
                )}
              {Utils.equalsIgnoreCase(
                this.state.questionType?.type,
                "ConfirmGroup"
              ) && (
                <div className="col-md-3 align-self-center mb-3 ms-3">
                  <label
                    htmlFor="exampleFormControlTextarea1"
                    className="MuiAutocomplete-label form-label ms-1"
                  >
                    Set to
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    disableClearable
                    autoComplete="off"
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.smsGroupList}
                    value={this.state.groupToJoin}
                    getOptionLabel={(option) => option.name}
                    defaultValue={this.state.groupToJoin}
                    onChange={(event, value) => {
                      this.handleSMSGroupChange(value);
                    }}
                    inputprops={{ style: { textTransform: "capitalize" } }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Please Select"
                        variant="outlined"
                        size="small"
                        className="autoComplete"
                        style={{ background: "#fff" }}
                      />
                    )}
                  />
                </div>
              )}
              {Utils.equalsIgnoreCase(
                this.state.questionType?.type,
                "SelectGroup"
              ) && (
                <>
                  <div className="col-md-3 align-self-center mt-.searchWrapper ms-3">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className="form-label ms-1"
                    >
                      Select Group options for message
                    </label>
                    <Multiselect
                      onRemove={this.onRemoveGroups.bind(this)}
                      onSelect={this.onSelectGroups.bind(this)}
                      options={this.state.smsGroupList}
                      selectedValues={this.state.selectedGroups}
                      displayValue="name"
                      showCheckbox
                      placeholder={
                        this.state.selectedGroups?.length === 0
                          ? "None"
                          : this.state.selectedGroups?.length > 1
                          ? `${this.state.selectedGroups?.length} groups selected`
                          : `${this.state.selectedGroups?.length} group selected`
                      }
                      hideSelectedList={true}
                    />
                    <span style={{ fontSize: "11px", color: "#000" }}>
                      Note: To add a new group or edit a group name, go to
                      Groups.
                    </span>
                  </div>
                </>
              )}
              {this.state.questionType?.type === "YesToContinue" && (
                <div className="row mb-3 ms-0">
                  <div className="col-md-6 ps-2 pe-0">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className="form-label"
                    >
                      If user's reply indicates they don't want to continue,
                      send this message
                    </label>
                    <textarea
                      value={this.state.discontinueText}
                      onChange={this.handleYesToCountinueChange.bind(this)}
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      // style={{ width: "518px" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="insertMessage"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Link
            className="anchortag"
            type="button"
            component="button"
            variant="body2"
            onClick={this.addQuestionItem.bind(this)}
            style={{ display: "flex", alignItems: "center" }}
          >
            <AddIcon style={{ fontSize: "20px", marginRight: "5px" }} /> Insert
            Message
          </Link>
          <hr
            style={{
              flexGrow: 1,
              marginLeft: "10px",
              borderTop: "1px solid black",
            }}
          />
        </div>
      </>
    );
  }

  viewMessageQuestion() {
    return (
      <>
        <tr
          style={{
            margin: "0",
          }}
        >
          <td
            style={{
              border: "0.5px solid #ece6e6",
              padding: "0.2em 0.5em",
              width: "5%",
              textAlign: "left",
            }}
          >
            <span style={{ float: "left" }}>{this.state.index}</span>
          </td>
          <td
            style={{
              border: "0.5px solid #ece6e6",
              padding: "0.2em 0.5em",
              width: "20%",
              textAlign: "left",
            }}
          >
            <span style={{ float: "left" }}>
              {this.state.questionType
                ? this.state.questionType?.description
                : ""}
            </span>
          </td>
          <td
            style={{
              border: "0.5px solid #ece6e6",
              padding: "0.2em 0.5em",
              width: "70%",
              textAlign: "left",
            }}
          >
            {this.state.question} <br />
            {this.state.discontinueText !== null
              ? "If No - " + this.state.discontinueText
              : ""}
          </td>
        </tr>
      </>
    );
  }
}
